@use "@fukuri-admins/ui/layout" as *;

/* Tab コンポーネントの root は width: 100% のため、
   ラッパーを fit-content にして border-bottom を文字幅に合わせる */
.tab {
  width: fit-content;
  max-width: 100%;
  min-width: 0;
}

.actions {
  display: flex;
  align-items: center;
  gap: spacing("8");
  margin-left: auto; /* .tab が fit-content で縮むため右寄せを担保 */
  flex-shrink: 0;
}

.dropdownMenuItem {
  gap: spacing("8");
}

.searchField {
  width: 269px;
}

.searchActions {
  display: flex;
  align-items: center;
  gap: spacing("8");
  margin-left: auto;
  flex-shrink: 0;
}
